import { render, staticRenderFns } from "./OSPFNeighborList.vue?vue&type=template&id=2843f07d&"
import script from "./OSPFNeighborList.vue?vue&type=script&lang=js&"
export * from "./OSPFNeighborList.vue?vue&type=script&lang=js&"
import style0 from "./OSPFNeighborList.vue?vue&type=style&index=0&id=2843f07d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports